import React, { useState } from 'react';
import { MdCheckCircle, MdDoDisturbAlt } from 'react-icons/md';

import { Flex, H5, Icon, Text, Toggle } from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

import { IPMatchingConfirmDialog } from './IPMatchingConfirmDialog';
import { useIPMatchingContext } from './IPMatchingProvider';

export const IPMatchingSection = () => {
  const { rootLevelEnablement, status } = useIPMatchingContext();
  const [updatedStatus, setUpdatedStatus] = useState<string>('');
  const [enablement, handleEnablement] = useState<boolean>(rootLevelEnablement);

  return (
    <>
      <Flex
        lss={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <H5>{t('ipMatching.title')}</H5>
        <IPMatchingConfirmDialog
          enablement={enablement}
          handleEnablement={handleEnablement}
          handleUpdateStatus={setUpdatedStatus}
        >
          {({ onToggle }) => (
            <Toggle
              lss={{ borderRadius: 'lg' }}
              value={enablement}
              onChange={onToggle}
            />
          )}
        </IPMatchingConfirmDialog>
      </Flex>
      <Flex
        lss={{ flexDirection: 'row', gap: '0.25rem', alignItems: 'center' }}
      >
        <Icon as={enablement ? MdCheckCircle : MdDoDisturbAlt} size={24} />
        <Text lss={{ fontWeight: 'bold', mr: 'sm' }}>
          {t(`labels.${enablement ? 'on' : 'off'}`)}
        </Text>
        {enablement && (
          <>
            <Text>|</Text>
            <Text lss={{ ml: 'sm' }}>
              {t('ipMatching.labels.enablement', {
                status: !!updatedStatus ? updatedStatus : status
              })}
            </Text>
          </>
        )}
      </Flex>
    </>
  );
};
